import React from 'react';
import CalendarioPedidos from '../../../components/Pedidos/Calendario';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as pedidoActions from '../../../reducers/pedidosReducer/actions'
import { calendarioPedidosReducerDataSelector } from '../../../selectors/pedidosSelector'
import { instalacionSelector } from '../../../selectors/sessionSelector'
import moment from 'moment';

const Calendario = ({sagaGetCalendarioPedidos, calendarioPedidos, instalacion}) => {
  const [value, setValue] = React.useState(0);
  const [valuePrev, setValuePrev] = React.useState(0);
  const [refresh, setRefresh] = React.useState(false);
  const [opened, setOpened] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);
  const [fecha, setFecha] = React.useState(moment().format('YYYY-MM-DD'));
  const [fechaPrev, setFechaPrev] = React.useState(moment().format('YYYY-MM-DD'));

  React.useEffect(() => {
    sagaGetCalendarioPedidos({ idInstalacion: instalacion.id, fecha: fecha, type: value === 0 ? 'pickup' : 'delivery' });
    if(fecha !== fechaPrev || value !== valuePrev) {
      setValuePrev(value);
      setFechaPrev(fecha);
      setOpened(false);
    }
  } , [value, fecha, refresh]);

  React.useEffect(() => {
    if(loaded){
      localStorage.setItem('calendarData', JSON.stringify({fecha, value, opened}));
    }
  } , [value, fecha, opened]);

  React.useEffect(() => {
    const calendarData = JSON.parse(localStorage.getItem('calendarData'));
    if(calendarData){
      sagaGetCalendarioPedidos({ idInstalacion: instalacion.id, fecha: calendarData.fecha, type: calendarData.value === 0 ? 'pickup' : 'delivery' });
      setFecha(calendarData.fecha);
      setFechaPrev(calendarData.fecha);
      setValue(calendarData.value);
      setValuePrev(calendarData.value);
      setOpened(calendarData.opened);
    }
    setLoaded(true);

    window.onbeforeunload = function (e) {
      localStorage.removeItem('calendarData');
      return undefined;
    };
    
  } , []);

    return (
        <CalendarioPedidos {...{value, setValue, fecha, setFecha, calendarioPedidos, refresh, setRefresh, setOpened, opened}} />
    );
  }

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
	    ...pedidoActions
	}, dispatch)
}

function mapStateToProps(state) {
	return {
        calendarioPedidos: calendarioPedidosReducerDataSelector(state),
        instalacion: instalacionSelector(state),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Calendario)